export const LANGUAGE_TOGGLE_DESCRIPTION = 'Toggle to select current language.'
